import { render, staticRenderFns } from "./TasksSection.vue?vue&type=template&id=653cc107&scoped=true&"
import script from "./TasksSection.vue?vue&type=script&lang=ts&"
export * from "./TasksSection.vue?vue&type=script&lang=ts&"
import style0 from "./TasksSection.vue?vue&type=style&index=0&id=653cc107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653cc107",
  null
  
)

export default component.exports